import { render } from "./AdminUserDetail.vue?vue&type=template&id=1e68d692&ts=true"
import script from "./AdminUserDetail.vue?vue&type=script&lang=ts"
export * from "./AdminUserDetail.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__